import React, { FC } from 'react';

import MobileValueColumn from './MobileValueColumn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faCheck } from '@fortawesome/free-solid-svg-icons';
//import Pagination from './Pagination';
interface Props {
    columns: { id: string; label: any; type?: string; cellStyle: string }[];
    data: { [key: string]: any }[];
    action?: (val: any) => void;
    getData?: (val: any) => void;
    pagination?: any;
    type?: string;
    setManualAction?: any;
    manualAction?: any;
    opened: number;
    setOpened: (number: number) => void;
    noAuto?: boolean;
    classNameTable?: string;
}

const MobileCard: FC<Props> = ({
    columns,
    data,
    opened,
    setOpened,
    action,
    setManualAction,
    manualAction,
    type,
}: Props) => {
    const handleChange = (id: any) => {
        manualAction[+id] = !manualAction[+id];
        setManualAction(manualAction);
    };

    const options: any = {
        adminWork: {
            column: 'Date',
            value: 'adminWorkDate',
        },
        bonus: {
            column: 'Date',
            value: 'createdAt',
        },
        session: {
            column: 'Date',
            value: 'seanceDateLabel',
        },
        expense: {
            column: 'Date',
            value: 'expenseDate',
        },
        internal: {
            column: 'Date',
            value: 'internalDate',
        },
    };
    const labelColumn = type ? options[type].column : '';
    const valueColumn = type ? options[type].value : '';

    return (
        <div>
            {data &&
                data.map((row: any, k) => {
                    return opened === k || row.totalColumn ? (
                        <div key={`key-m${k}`} className={`d-flex mb-3  border-secondary border border-1 `}>
                            <div
                                style={
                                    row.totalColumn
                                        ? { minWidth: 100, background: '#f1f1f1' }
                                        : { minWidth: 100, color: 'white', background: 'rgba(62, 129, 185, 0.7)' }
                                }
                            >
                                {columns.map(
                                    (column: { label: string; id: string; type?: string; cellStyle: string }, k) => {
                                        if (row.totalColumn && !row[column.id]) {
                                            return null;
                                        }
                                        return (
                                            <div
                                                style={{ minHeight: 50, fontSize: 16, textAlign: 'center' }}
                                                className={
                                                    'border-secondary  d-flex justify-content-center align-items-center border border-bottom-1'
                                                }
                                                key={`th-${k}`}
                                            >
                                                {opened > -1 && column.id === 'action' ? '' : column.label}
                                                {opened > -1 && column.id === 'action' ? (
                                                    <FontAwesomeIcon
                                                        onClick={(value) => action && action(false)}
                                                        style={{ height: '19px' }}
                                                        className={'ml-2 '}
                                                        icon={faChevronUp}
                                                    />
                                                ) : null}
                                            </div>
                                        );
                                    },
                                )}
                            </div>
                            <div style={{ minWidth: 'calc(100% - 100px)' }}>
                                {row && row.ColumnForm ? (
                                    <row.ColumnForm
                                        action={action ? action : (val: any) => false}
                                        key={`ke${k}`}
                                        columns={columns}
                                        row={row}
                                    />
                                ) : (
                                    <MobileValueColumn
                                        colorColumn={row?.colorColumn}
                                        key={`ke${k}`}
                                        columns={columns}
                                        row={row}
                                    />
                                )}
                            </div>
                        </div>
                    ) : (
                        <div
                            key={`key-m${k}`}
                            style={{ position: 'relative' }}
                            className={`d-flex mb-3  border-secondary border border-1 `}
                        >
                            <div
                                onClick={() => setOpened(k)}
                                className={`border-secondary ${
                                    row.totalColumn ? 'invisible' : ''
                                }  d-flex justify-content-center align-items-center border border-bottom-1`}
                                style={{
                                    minWidth: 100,
                                    color: 'white',
                                    background: 'rgba(62, 129, 185, 0.7)',
                                    minHeight: 50,
                                    fontSize: 16,
                                    textAlign: 'center',
                                }}
                            >
                                {labelColumn} <FontAwesomeIcon className={'ml-2 mt-1'} icon={faChevronDown} />
                            </div>
                            <div
                                className={
                                    'border-secondary  d-flex justify-content-center align-items-center border border-bottom-1'
                                }
                                style={{ minHeight: 50, fontSize: 14, minWidth: 'calc(100% - 100px)' }}
                            >
                                {row ? (
                                    manualAction ? (
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                position: 'relative',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {row[valueColumn]}
                                                {row.isConfirmed ? (
                                                    <FontAwesomeIcon
                                                        style={{
                                                            position: 'absolute',
                                                            right: '0%',
                                                            color: 'green',
                                                            top: '-3px',
                                                            padding: 1,
                                                            background: 'white',
                                                        }}
                                                        className={'ml-2 mt-1'}
                                                        icon={faCheck}
                                                    />
                                                ) : null}
                                            </div>
                                            <div
                                                onClick={(value) => handleChange(+row.id)}
                                                style={{
                                                    width: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',

                                                    background: 'rgba(62, 129, 185, 0.3)',
                                                }}
                                            >
                                                <input
                                                    style={{ width: '100%', height: '50%' }}
                                                    type="checkbox"
                                                    checked={manualAction[+row.id]}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            {row[valueColumn]}
                                            {row.isConfirmed ? (
                                                <FontAwesomeIcon
                                                    style={{
                                                        position: 'absolute',
                                                        right: '3%',
                                                        color: 'green',
                                                        top: 0,
                                                    }}
                                                    className={'ml-2 mt-1'}
                                                    icon={faCheck}
                                                />
                                            ) : null}
                                        </div>
                                    )
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default MobileCard;
